import React from 'react';
import cx from 'classnames';
import {
  getCurrentSoftwareNumber,
  getInitialSoftwareNumber,
  overrideSoftwareNumber,
} from '../../../../store/software-number';
import './index.scss';

export const HYBRID_SOFTWARE_NUMBERS = [391991, 371895, 371897];
export const CORRESPONDING_BIKE_SOFTWARE_NUMBERS = [381384, 381384, 373116];

export function HybridConsoleModePicker() {
  const ellipticalSoftwareNumber = getInitialSoftwareNumber();
  if (-1 === HYBRID_SOFTWARE_NUMBERS.indexOf(ellipticalSoftwareNumber)) {
    return null;
  }
  const currentSoftwareNumber = getCurrentSoftwareNumber();
  const ellipticalActive = currentSoftwareNumber === ellipticalSoftwareNumber;
  return (
    <div className="hybrid-console-mode-picker">
      <button
        className={cx(ellipticalActive && 'active')}
        type="button"
        disabled={ellipticalActive}
        onClick={switchToElliptical}
      >
        Elliptical
      </button>
      <button
        className={cx(!ellipticalActive && 'active')}
        disabled={!ellipticalActive}
        type="button"
        onClick={switchToBike}
      >
        Bike
      </button>
    </div>
  );
}

export function switchToElliptical() {
  const elliptical = getInitialSoftwareNumber();
  overrideSoftwareNumber(elliptical);
}

export function switchToBike() {
  const elliptical = getInitialSoftwareNumber();
  const bike = translateEllipticalToBikeSoftwareNumber(elliptical);
  overrideSoftwareNumber(bike);
}

export function translateEllipticalToBikeSoftwareNumber(softwareNumber) {
  const index = HYBRID_SOFTWARE_NUMBERS.indexOf(softwareNumber);
  return CORRESPONDING_BIKE_SOFTWARE_NUMBERS[index];
}
